import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnyMxRecord } from 'dns';
import { StaticPageJSHelper } from 'src/helper/javascript-shared-helper';
import { MessageService } from 'src/helper/message.service';
import { AdminService } from 'src/pages/admin/admin.service';
import { emailValidationRegx } from 'src/pages/admin/shared/static-lookups/lookup';
import * as $ from 'jquery';
import { DialogServices } from 'src/pages/dialogService';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-static-footer',
  templateUrl: './static-footer.component.html',
  styleUrls: ['./static-footer.component.css'],
})
export class StaticFooterComponent implements OnInit {
  resetLan() {
    var iframe = document.getElementsByClassName('goog-te-banner-frame')[0];
    if (!iframe) return;
    //@ts-ignore
    var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
    var restore_el = innerDoc.getElementsByTagName('button');

    for (var i = 0; i < restore_el.length; i++) {
      if (restore_el[i].id.indexOf('restore') >= 0) {
        restore_el[i].click();
        var close_el = innerDoc.getElementsByClassName('goog-close-link');
        close_el[0].click();
        return;
      }
    }
  }

  year: any;

  formGroup: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: AdminService,
    private messageService: MessageService,
    private dialogServices: DialogServices,
    private modalInstance: NgbActiveModal
  ) {
    $('body').on('change', '#google_translate_element select', function (e) {
      alert(
        '𝐃𝐢𝐬𝐜𝐥𝐚𝐢𝐦𝐞𝐫: This is a translation from Google which may not be entirely accurate. Please check first if the translation you want is available under "iTIM Course Tracks" ==> "Languages".'
      );
    });
  }

  ngOnInit(): void {
    setInterval(() => {
      var timer = localStorage.getItem('timer');
      if (timer != 'true') this.click();
    }, 60000);
    this.loadForm();
    this.year = new Date().getFullYear();
    StaticPageJSHelper.loadScript();
  }

  loadForm(data?: any) {
    this.formGroup = this.fb.group({
      name: [
        data?.name ? data?.name : null,
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
      email: [
        data?.email ? data?.email : null,
        Validators.compose([
          Validators.required,
          Validators.pattern(emailValidationRegx),
          Validators.maxLength(50),
          Validators.required,
        ]),
      ],
    });
  }

  save() {
    if (this.formGroup.valid) {
      this.apiService.ContactUs(this.formGroup.value).then((t) => {
        this.messageService.successMessage(
          'Request for information submitted. You will hear from us soon.'
        );
        this.router.navigate(['/index']);
      });
    }
    this.formGroup.markAllAsTouched();
  }

  click() {
    localStorage.setItem('timer', 'true');
    document.getElementById('bt1').click();
  }
  close(result: any) {
    this.modalInstance.close(result);
  }

  translatePopUp() {
    this.dialogServices
      .translate(
        {
          title: 'Translate',
          message:
            'Disclaimer: This is a translation from Google which may not be entirely accurate. Please check first if the translation you want is available under "iTIM Course Tracks" ==>  "Languages"',
          titleValue: { module: 'Translate' },
          messageValue: {},
        },
        { size: 'md' }
      )
      .result.then((result) => {
        if (result) {
          //document.getElementsByClassName('goog-te-combo')
          let selectElement =
            document.getElementsByClassName('dropdown d-flex');
          let event = new MouseEvent('mousedown');

          console.log(document.getElementsByClassName('dropdown d-flex'));

          this.close(true);
        }
      });
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
